import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=1699487b"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports